/* ₹99 Store theme.js — no dependencies, Shopify Ajax + Section Rendering API */
(function () {
  'use strict';

  /* Locale-aware base. Shopify injects window.Shopify.routes.root; we fall back
     to the Liquid-rendered routes in theme.liquid, then to "/". */
  var SHOPIFY_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || null;
  var LIQUID = (window.theme && window.theme.routes) || {};
  var STR = (window.theme && window.theme.strings) || {};
  var ROOT = SHOPIFY_ROOT || LIQUID.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';

  var CART_URL = LIQUID.cart || (ROOT + 'cart');
  var CART_ADD = ROOT + 'cart/add.js';
  var CART_CHANGE = ROOT + 'cart/change.js';
  var CART_JS = ROOT + 'cart.js';

  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  /* ------------------------------------------------------------------ */
  /* Helpers                                                            */
  /* ------------------------------------------------------------------ */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function toast(html, kind) {
    var t = document.createElement('div');
    t.className = 'toast toast--' + (kind || 'ok');
    t.innerHTML = html;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
    }, 4000);
  }

  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function showError(msg, scope) {
    var box = scope ? $('[data-cart-error]', scope) : $('[data-cart-error]');
    if (box) { box.textContent = msg; box.hidden = false; }
    else toast(msg, 'err');
  }
  function clearErrors() {
    $$('[data-cart-error]').forEach(function (b) { b.hidden = true; b.textContent = ''; });
  }

  /* Reads a Shopify Ajax API error body into a human message. */
  function apiMessage(data) {
    if (!data) return STR.add_error || 'Something went wrong.';
    return data.description || data.message || (STR.add_error || 'Something went wrong.');
  }

  /* ------------------------------------------------------------------ */
  /* Mobile menu                                                        */
  /* ------------------------------------------------------------------ */
  var menu = $('.mobile-menu');
  function closeMenu() { if (menu) menu.classList.remove('open'); document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.menu-toggle') && menu) {
      menu.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('.mobile-menu__close')) closeMenu();
    if (menu && e.target === menu) closeMenu();
  });

  /* ------------------------------------------------------------------ */
  /* Quantity steppers (delegated — survives section re-render)          */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = $('input', btn.closest('.qty'));
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = min;
    val += parseInt(btn.getAttribute('data-qty-change'), 10);
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------ */
  /* Gallery thumbs (delegated)                                          */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var main = $('[data-gallery-main]');
    if (main) main.src = thumb.getAttribute('data-full');
    $$('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('active'); });
    thumb.classList.add('active');
  });

  /* ------------------------------------------------------------------ */
  /* Sticky mobile buy bar                                               */
  /* ------------------------------------------------------------------ */
  var sticky = $('[data-sticky-bar]');
  var anchor = $('[data-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting || en.boundingClientRect.top > 0) sticky.classList.remove('show');
        else sticky.classList.add('show');
      });
    }, { threshold: 0 }).observe(anchor);
  }

  /* ------------------------------------------------------------------ */
  /* Option value picker — Section Rendering API                         */
  /*                                                                     */
  /* No variants JSON. On change we ask Shopify to re-render this        */
  /* section with ?option_values=<ids>, so availability, price and the   */
  /* hidden variant id always come from Shopify. Works past 250 variants */
  /* and across combined listings.                                       */
  /* ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-option-value-id]');
    if (!input) return;

    var productEl = input.closest('[data-product-section]');
    var picker = input.closest('[data-variant-picker]');
    if (!productEl || !picker) return;

    clearErrors();
    picker.classList.add('is-loading');

    var sectionId = productEl.getAttribute('data-section-id');
    var oldUrl = productEl.getAttribute('data-product-url');
    var newUrl = input.getAttribute('data-product-url') || oldUrl;

    var ids = $$('input[type="radio"]:checked', picker)
      .map(function (i) { return i.getAttribute('data-option-value-id'); })
      .filter(Boolean);

    var params = ids.length ? '&option_values=' + ids.join(',') : '';
    var url = newUrl + '?section_id=' + encodeURIComponent(sectionId) + params;

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('render');
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var freshProduct = $('[data-product-section]', doc);
        if (!freshProduct) throw new Error('render');

        /* Combined listing: the option value points at a sibling product. */
        if (newUrl && newUrl !== oldUrl) {
          productEl.parentNode.replaceChild(freshProduct, productEl);
          var refocus = document.getElementById(input.id);
          if (refocus) refocus.focus();
          return;
        }

        /* Same product: swap only the pieces Shopify recomputed. Leaving the
           payment_button in place keeps Shopify's accelerated checkout script
           bound to it. */
        var freshPicker = $('[data-variant-picker]', freshProduct);
        if (freshPicker) picker.innerHTML = freshPicker.innerHTML;

        var freshPrice = $('[data-price-block]', freshProduct);
        var priceBlock = $('[data-price-block]', productEl);
        if (freshPrice && priceBlock) priceBlock.innerHTML = freshPrice.innerHTML;

        var freshId = $('[data-variant-id-input]', freshProduct);
        var idInput = $('[data-variant-id-input]', productEl);
        var variantId = freshId ? freshId.getAttribute('value') : '';
        if (idInput) idInput.value = variantId || '';

        var freshBtn = $('[data-add-btn]', freshProduct);
        var btn = $('[data-add-btn]', productEl);
        var freshLabel = $('[data-add-label]', freshProduct);
        var label = $('[data-add-label]', productEl);
        if (btn && freshBtn) btn.disabled = freshBtn.hasAttribute('disabled');
        if (label && freshLabel) label.textContent = freshLabel.textContent.trim();

        var freshMain = $('[data-gallery-main]', freshProduct);
        var main = $('[data-gallery-main]', productEl);
        if (freshMain && main && freshMain.getAttribute('src')) main.src = freshMain.getAttribute('src');

        var freshSticky = doc.querySelector('[data-sticky-price]');
        var stickyPrice = $('[data-sticky-price]');
        if (freshSticky && stickyPrice) stickyPrice.textContent = freshSticky.textContent.trim();
        if (sticky) sticky.hidden = !variantId || (btn && btn.disabled);

        if (variantId) {
          history.replaceState({}, '', oldUrl + '?variant=' + variantId);
        }

        var again = document.getElementById(input.id);
        if (again) again.focus();
      })
      .catch(function () {
        /* Rendering failed — hard-navigate so the buyer still lands on a
           correct, purchasable page rather than a stale one. */
        window.location.href = newUrl + '?' + (ids.length ? 'option_values=' + ids.join(',') : '');
      })
      .then(function () { picker.classList.remove('is-loading'); });
  });

  /* ------------------------------------------------------------------ */
  /* Add to cart                                                         */
  /* ------------------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id !== 'product-form') return;
    if (!window.fetch) return; /* let it POST natively */

    e.preventDefault();
    clearErrors();

    var btn = $('[data-add-btn]', form);
    var label = $('[data-add-label]', form);
    var restore = label ? label.textContent : 'Add to cart';
    if (btn) btn.disabled = true;
    if (label) label.textContent = STR.adding || 'Adding…';

    fetch(CART_ADD, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          var err = new Error(apiMessage(res.data));
          err.handled = true;
          throw err;
        }
        return fetch(CART_JS, { credentials: 'same-origin', headers: JSON_HEADERS })
          .then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setCartCount(cart.item_count);
        toast((STR.added || 'Added to cart') + ' · <a href="' + CART_URL + '">' + (STR.view_cart || 'View cart') + ' →</a>');
      })
      .catch(function (err) {
        if (!err.handled) { form.submit(); return; }  /* network failure → real POST */
        showError(err.message, form);
      })
      .then(function () {
        if (btn) btn.disabled = false;
        if (label) label.textContent = restore;
      });
  });

  /* Sticky button routes through the real form so the AJAX path runs. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-sticky-add]')) return;
    var form = document.getElementById('product-form');
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });

  /* ------------------------------------------------------------------ */
  /* Cart line changes — /cart/change.js + bundled section rendering     */
  /* ------------------------------------------------------------------ */
  function renderCart(sectionsPayload) {
    var section = $('[data-cart-section]');
    if (!section) return;
    var id = section.getAttribute('data-section-id');
    var html = sectionsPayload && sectionsPayload[id];
    if (!html) { window.location.reload(); return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-section]', doc);
    if (fresh) section.innerHTML = fresh.innerHTML;
    else window.location.reload();
  }

  function changeLine(key, quantity) {
    var section = $('[data-cart-section]');
    if (!section) return;
    var sectionId = section.getAttribute('data-section-id');
    section.classList.add('is-loading');
    clearErrors();

    fetch(CART_CHANGE, {
      method: 'POST',
      credentials: 'same-origin',
      headers: JSON_HEADERS,
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionId,
        sections_url: CART_URL
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(apiMessage(res.data));
        setCartCount(res.data.item_count);
        renderCart(res.data.sections);
      })
      .catch(function (err) { showError(err.message); })
      .then(function () { section.classList.remove('is-loading'); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input || !window.fetch) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    changeLine(input.getAttribute('data-line-key'), qty);
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-remove]');
    if (!link || !window.fetch) return;
    e.preventDefault();
    changeLine(link.getAttribute('data-line-key'), 0);
  });
})();
